import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { removeAccents } from '../../utils/utils'

// Escolha de motorista por nome (listall carregado uma vez e filtrado no cliente,
// ignorando acento). Emite o motorista escolhido, ou null quando o campo é limpo
// ou editado à mão depois de escolher — quem usa só olha o emit, nunca o texto.
@Component({
  selector: 'driver-autocomplete',
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  template: `
    <mat-form-field class="input-tg w-full" appearance="outline">
      <mat-label>{{ label }}</mat-label>
      <input matInput [formControl]="control" [matAutocomplete]="auto" />
      @if (control.value) {
      <button mat-icon-button matSuffix type="button" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
      }
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayNome" (optionSelected)="onSelected($event.option.value)">
        @for (driver of filtered; track driver.id) {
        <mat-option [value]="driver">{{ driver.id }} - {{ driver.nome }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  `,
  standalone: true,
})
export class DriverAutocompleteComponent implements OnInit {
  constructor(
    private driverService: DriverService,
    private destroyRef: DestroyRef,
  ) {}

  @Input() label = 'Motorista'
  // Escolha que já existia (ex.: modal de filtro reaberto com o filtro aplicado):
  // aparece preenchida sem emitir driverChange de novo.
  @Input() initial: any | null = null
  @Output() driverChange = new EventEmitter<any | null>()

  control = new FormControl<any>('')
  drivers: any[] = []
  filtered: any[] = []
  private selected: any = null

  ngOnInit(): void {
    if (this.initial) {
      this.selected = this.initial
      this.control.setValue(this.initial, { emitEvent: false })
    }

    this.driverService.listDriver().subscribe({
      next: (res: any) => {
        this.drivers = res.data ?? []
        this.filter(this.control.value)
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })

    this.control.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      if (typeof value === 'string') {
        // texto digitado: qualquer escolha anterior deixa de valer
        if (this.selected) {
          this.selected = null
          this.driverChange.emit(null)
        }
        this.filter(value)
      }
    })
  }

  displayNome = (driver: any): string => (driver && typeof driver === 'object' ? driver.nome : (driver ?? ''))

  onSelected(driver: any): void {
    this.selected = driver
    this.driverChange.emit(driver)
  }

  clear(): void {
    this.control.setValue('')
  }

  private filter(value: any): void {
    const text = typeof value === 'string' ? removeAccents(value.toLowerCase()) : ''
    this.filtered = this.drivers
      .filter((d) => removeAccents((d?.nome || '').toLowerCase()).includes(text))
      .slice(0, 50)
  }
}
